import { useEffect, useState } from "react";
import { useAppSelector } from "./hook";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { createChatList } from "../utils/utils";
export function useBlackList() {
    const guest = useAppSelector(state => { var _a; return (_a = state.app) === null || _a === void 0 ? void 0 : _a.selectedChat; });
    const currentUser = useAppSelector(state => state.app.currentUser);
    const myBlackList = useAppSelector(state => { var _a; return (_a = state.app) === null || _a === void 0 ? void 0 : _a.blackList; }).some(item => (item === null || item === void 0 ? void 0 : item.uid) === (guest === null || guest === void 0 ? void 0 : guest.uid));
    const [guestBlackList, setGuestBlackList] = useState(false);
    useEffect(() => {
        if (guest) {
            const getGuestBlackList = onSnapshot(doc(db, guest.email, "blacklist"), (doc) => {
                if (doc.data()) {
                    const isBan = createChatList(doc.data()).some(item => item.uid === currentUser.uid);
                    isBan ? setGuestBlackList(true) : setGuestBlackList(false);
                }
            });
            return () => getGuestBlackList();
        }
    }, [guest]);
    return { myBlackList, guestBlackList };
}
